export function FourOOne() {
  return (
    <>
      <h2>ERROR 401</h2>
      <h1>Access Denied</h1>
    </>
  )
}
